export default __webpack_public_path__ + "static/media/classplus-leaders.4b450641.webp";